import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupRestrictedContentProps } from './msg-group-restricted-content';
import { MsgGroupRestrictedContent } from './msg-group-restricted-content';

export interface MsgGroupRestrictedPreviewProps extends MsgGroupRestrictedContentProps {}

export const MsgGroupRestrictedPreview = memo(function MsgGroupRestrictedPreview({
  message,
}: MsgGroupRestrictedPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupRestrictedContent message={message} />
    </LastMessageSystem>
  );
});
